import { Stagger, Parallax } from "@/motion";
import { ShinyButton } from "@/components/ui/shiny-button";
import { PRODUCTS } from "@/data/products";

const feature = PRODUCTS[0];

export function Hero() {
  return (
    <section id="top" className="hero" aria-labelledby="hero-title">
      <div className="hero__aurora">
        <div className="shell hero__inner">
          {/* onMount, not whileInView — this is above the fold. */}
          <Stagger className="hero__copy" onMount interval={0.1} delay={0.15}>
            <Stagger.Item as="p" className="eyebrow" distance={12}>
              New — Metal Vent Tech
            </Stagger.Item>

            <Stagger.Item as="div" distance={40} duration={0.8}>
              <h1 id="hero-title" className="hero__title">
                Trust your path,
                <br />
                Flow your pace.
              </h1>
            </Stagger.Item>

            <Stagger.Item as="p" className="hero__lede measure" distance={24}>
              Performance apparel that gets out of the way. Built for the run you
              actually do — not the one on the poster.
            </Stagger.Item>

            <Stagger.Item as="div" className="hero__actions" distance={20}>
              <ShinyButton
                onClick={() =>
                  document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Shop the range
              </ShinyButton>
              {/* secondary: same mechanics, no filled body */}
              <ShinyButton
                onClick={() =>
                  document.getElementById("brand")?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Our story
              </ShinyButton>
            </Stagger.Item>
          </Stagger>

          {/* Parallax sits outside the Stagger — a parent transforming every frame
              would invalidate its children's compositing. */}
          <Parallax className="hero__media" amount={40}>
            <img src={feature.image} alt={feature.alt} className="hero__shot" width={720} height={720} />
          </Parallax>
          </div>
      </div>
    </section>
  );
}
